import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fab"]

  connect() {
    const hero = document.getElementById("main-content")
    if (!hero) return

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.fabTarget.classList.toggle("opacity-0", entry.isIntersecting)
        this.fabTarget.classList.toggle("pointer-events-none", entry.isIntersecting)
      },
      { threshold: 0 }
    )
    this.observer.observe(hero)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
